import {type ReactNode} from 'react';
import {Provider} from 'jotai';
import {store} from '@/store';

interface JotaiProviderProps {
    children: ReactNode;
}

export function JotaiProvider({
    children,
}: JotaiProviderProps): React.ReactElement {
    return <Provider store={store}>{children}</Provider>;
}
